import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

import { AUTH_MANAGER } from '@asset-solutions/customer-portal/auth/data-access';
import { BaseMetadataService, LoggerConfig, type LoggerMetadata } from '@asset-solutions/shared/logging';

@Injectable()
export class CustomerPortalMetadataService extends BaseMetadataService {
  private readonly currentUser = inject(AUTH_MANAGER).currentUser();
  private readonly router = inject(Router);

  public override getMetadata(level: number, config: LoggerConfig, message?: any, additional?: any[]): LoggerMetadata {
    if (config.logToServer) {
      additional = (additional || []).concat([{ appUrl: this.router.url }, { user: this.currentUser?.email }]);
    }
    return super.getMetadata(level, config, message, additional);
  }
}
